import SpriteSymbol from "../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "TimerS",
  "use": "TimerS-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"TimerS\">\n    <path d=\"M14 2a1 1 0 110 2h-1v1.062a7.96 7.96 0 013.906 1.618l.387-.387a1 1 0 111.414 1.414l-.387.387A8 8 0 1111 5.062V4h-1a1 1 0 010-2h4zm-2 5a6 6 0 100 12 6 6 0 000-12zm0 2a1 1 0 011 1v2.586l1.207 1.207a1 1 0 01-1.414 1.414l-1.5-1.5A1 1 0 0111 13v-3a1 1 0 011-1z\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol